export enum MDMStatus {
  INSTALLED = 'INSTALLED',
  NOT_INSTALLED = 'NOT_INSTALLED',
  REQUIRES_DESKTOP_APP = 'REQUIRES_DESKTOP_APP',
  LOCKED = 'LOCKED',
  LOCK_TIMEOUT = 'LOCK_TIMEOUT',
  LOCK_ERROR = 'LOCK_ERROR',
  WIPED = 'WIPED',
  WIPE_REQUESTED = 'WIPE_REQUESTED',
  WIPE_TIMEOUT = 'WIPE_TIMEOUT',
  WIPE_ERROR = 'WIPE_ERROR',
  UNENROLL_REQUESTED = 'UNENROLL_REQUESTED',
  UNENROLL_DONE = 'UNENROLL_DONE',
  UNENROLL_ERROR = 'UNENROLL_ERROR',
}
